/* eslint-disable import/prefer-default-export */
export function getTextstring(string) {
    return chayns.utils.lang.get(string) || '';
}
